import { connect } from 'react-redux';
import { push } from 'redux-first-history';

import { logError } from '@zg-rentals/log-error';

import ConfirmRentDetailsPage from './component';
import { getRachelDashboard, requestRentDetailsFromInvite } from '@renter-hub/actions/requests';
import type { ErrorInterface } from '@common/types';
import { showPageNotification } from '@common/actions/NotificationActions';
import { checkRequestActionSuccess, getSignInPage } from '@common/paymentsUtils/api';
import { DEFAULT_ERROR } from '@renter-hub/constants/notifications';
import HTTP_STATUS from '@common/constants/HttpConstants';
import OnboardingStatus from '@renter-hub/constants/onboardingStatus';
import paths from '@renter-hub/pathsManifest';

const mapStateToProps = (state) => {
  return {
    rentDetails: state.payments.renter.onboarding.rentDetails,
    onboardingStatus: state.payments.renter.dashboard.onboardingStatus,
    requestStatus: state.payments.renter.onboarding.requestStatus,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, brand, inviteToken, onboardingStatus, propertyId }) => ({
  requestRentDetails: async () => {
    try {
      // Request to get the rent details from the invite token
      const response = await dispatch(requestRentDetailsFromInvite(inviteToken));
      await checkRequestActionSuccess(response);

      return { error: false, data: response.payload };
    } catch (err) {
      const error = err as ErrorInterface;
      if (error.action && error.action.payload) {
        const { httpStatus, status } = error.action.payload;
        const resolvedStatus = httpStatus ?? status;

        // If 401 status, redirect to sign-in
        if (resolvedStatus === HTTP_STATUS.SC_UNAUTHORIZED) {
          window.location = getSignInPage();
          return null;
        }
      }

      logError({ error: err });
      dispatch(showPageNotification(DEFAULT_ERROR));
      return { error: true };
    }
  },
  onCreateRenterAccountSuccess: async (featureFlagEnableRentReporting) => {
    try {
      // Request the latest renter status
      const [renterStatusResponse] = await dispatch(getRachelDashboard({ encryptedInvite: inviteToken, propertyId }));
      await checkRequestActionSuccess(renterStatusResponse);

      // If term complete, navigate to the dashboard
      if (onboardingStatus === OnboardingStatus.TERM_COMPLETE) {
        return dispatch(push(baseUrl));
      }

      // Navigate to the next page
      const nextPage = featureFlagEnableRentReporting ? paths.paymentReportingOptInPage : paths.paymentInfoPage;
      await dispatch(push(baseUrl + nextPage));

      return { error: false };
    } catch (err) {
      const error = err as ErrorInterface;
      if (error.action && error.action.payload) {
        const { httpStatus: status } = error.action.payload;

        // If 401 status, redirect to sign-in
        if (status === HTTP_STATUS.SC_UNAUTHORIZED) {
          window.location = getSignInPage();
          return null;
        }
      }

      logError({ error: err });
      dispatch(showPageNotification(DEFAULT_ERROR));
      return { error: true };
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmRentDetailsPage);
